<template>
  <section class="comp-prizedraw" v-if="compProps.allPrize.prizeList">
    <toast v-model="showToast" v-if="showToast" :msg="msg"></toast>
    <!-- 中奖纪录滚动 -->
    <div class="prize-history" :style="{background:compProps.allPrize.colourOfCountdown}" v-if="compProps.otherPrize && compProps.otherPrize.length">
      <ul class="history-wrapper" :style="{transform: 'translateY('+-2.4*currPrizeHistoryIndex+'rem)',transition:currPrizeHistoryIndex?'0.5s':'none'}">
        <li class="history-item" v-for="(item,index) in compProps.otherPrize" :key="index">
          <img class="item-icon" :src="item.headUrl">
          <span class="item-number">{{item.luckPeople}}</span>
          <span class="item-text">{{item.prizeName}}</span>
        </li>
      </ul>
    </div>
    <!-- 抽奖大转盘 -->
    <div class="prizedraw-wrapper" :style="{backgroundImage:`url(${picHost}${compProps.allPrize.pictureOfTurntableUrl})`}">
      <div class="prizedraw-list">
        <ul class="turntable-wrapper" v-if="compProps.allPrize.prizeList && compProps.allPrize.prizeList.length">
          <li v-for="(item,index) in compProps.allPrize.prizeList" :key="index" class="prize-item" :class="{'active':orderNum==item.orderNum,'drawBtn':item.prizeType==-1}">
            <!-- 立即抽奖按钮 -->
            <div v-if="item.prizeType==-1" class="turntable-item">
              <img :src="picHost+compProps.allPrize.pictureOfLottery" data-itemtext="抽奖转盘" data-actionid="9" :data-itemotherinfo="id" @click="drawprize">
            </div>
            <!-- 奖品 -->
            <div v-else class="turntable-item">
              <img :src="item.prizeType?picHost+item.pictureUrl:picHost+compProps.allPrize.pictureOfThank">
            </div>
            <div class="turntable-item-mark"></div>
          </li>
        </ul>
      </div>
      <div class="prize-num">
        <!-- 单个用户活动期间 -->
        <p v-if="compProps.allPrize.lotteryLimitType==1">本次活动还剩<span :style="{color:compProps.allPrize.colourOfHighlight}"> {{compProps.allPrize.lastNum}} </span>次抽奖机会哦</p>
        <!-- 单个用户每天 -->
        <p v-if="compProps.allPrize.lotteryLimitType==2">今天还剩<span :style="{color:compProps.allPrize.colourOfHighlight}"> {{compProps.allPrize.lastNum}} </span>次抽奖机会哦</p>
      </div>
    </div>
    <div class="my-prize-btn" @click="isShowMyPrize(true)" :style="{color:compProps.allPrize.colourOfWinningFont}"  v-if="compProps.myPrize && compProps.myPrize.length">查看我的奖品</div>
    <!-- 以下弹层部分 -->
    <!-- 中奖弹层 -->
    <div v-if="showDialog" class="prizedraw-dialog" @click.self="doShowDialog(false)">
      <div class="prize-all-img">
        <img src="https://pic.tujia.com/upload/festatic/2406/7752abb009636e89.png" @click="handleBtn" class="null-prize" v-if="popupContentType == null"/>
        <img :src="picHost+prize.popupPic" @click="handleBtn" v-else/>
        <img src="https://pic.tujia.com/upload/festatic/2401/8e6444ea17cb7dec.png" class="close-img" @click="doShowDialog(false)"/>
      </div>
    </div>
    <!-- 实体奖品填写邮寄地址 -->
    <div v-if="addressDialog" class="prizedraw-dialog" @click.self="doAddressDialog(false)">
      <div class="dialog-wrapper">
        <div @click="doAddressDialog(false)" class="dialog-close" :style="`background-image: url('${baseUrl}static/imgs/close-btn.png')`"></div>
        <div class="dialog-title">请确认递送信息</div>
        <ul class="dialog-from">
          <li class="from-name">姓名：
            <div class="f-border-line-gray-warp"><input type="text" placeholder="请输入姓名" v-model="name" class="dialog-input"><div class="f-border-line-gray"></div></div>
          </li>
          <li class="from-phone">手机：
            <div class="f-border-line-gray-warp"><input type="number" placeholder="请输入手机" v-model="phone" class="dialog-input"><div class="f-border-line-gray"></div></div>
          </li>
          <li class="from-address">地址：
            <div class="f-border-line-gray-warp"><input type="text" placeholder="请输入地址" v-model="address" class="dialog-input"><div class="f-border-line-gray"></div></div>
          </li>
          <li class="from-postcode">邮编：
            <div class="f-border-line-gray-warp"><input type="number" placeholder="请输入邮编" v-model="postCode" class="dialog-input"><div class="f-border-line-gray"></div></div>
          </li>
        </ul>
        <button class="dialog-address-btn" @click="confirmAddress">确认</button>
        <p class="dialog-text">*请仔细核实地址信息，提交后不能修改</p>
      </div>
    </div>
    <!-- 我的奖品页 -->
    <tj-popup v-model="isMyPrizesShow" :overlay="false" position="right" class="myprize-container">
      <div class="header-container" v-if="isTujiaAppEnv">
        <div class="return-btn" @click="isShowMyPrize(false)">
          <img src="https://pic.tujia.com/upload/festatic/2405/0d438af9c3c1d5ca.png" class="icon-back"/>
        </div>
        <div class="title_box">我的奖品</div>
      </div>
      <div class="myprize-content" :class="{'isTujia': isTujiaAppEnv}">
        <div class="myprize-list" v-for="(item, index) in compProps.myPrize" :key="index">
          <p class="myprize-type-name">{{item.title}}</p>
          <div class="myprize-item" @click="checkPrizeDetail(prizeItem)" v-for="(prizeItem, i) in item.prizeList" :key="i">
            <img :src="picHost+prizeItem.prizePicUrl" class="prize-img"/>
            <div class="prize-info">
              <p class="title">{{prizeItem.prizeName}}</p>
              <p class="text">中奖时间：{{prizeItem.lotteryTime}}</p>
            </div>
            <div class="myprize-btn">
              <span v-if="prizeItem.prizeType == 1">{{!prizeItem.receiveAddress ? '去填地址' : '已填地址'}}</span>
              <span class="iconfont icon-arrow" v-if="(prizeItem.prizeType == 1 && !prizeItem.receiveAddress) || prizeItem.prizeType == 4"></span>
            </div>
          </div>
        </div>
        <div class="bottom-btn" @click="isShowMyPrize(false)"><img src="https://pic.tujia.com/upload/festatic/2406/02c022c7a56e69a6.png"/>返回活动</div>
      </div>
    </tj-popup>
    <!-- 优惠券详情 -->
    <tj-popup v-model="prizeDetailShow" :overlay="false" position="right" class="myprize-container">
      <div class="header-container" v-if="isTujiaAppEnv">
        <div class="return-btn" @click="closePrizeDetail">
          <img src="https://pic.tujia.com/upload/festatic/2405/0d438af9c3c1d5ca.png" class="icon-back"/>
        </div>
        <div class="title_box">优惠券</div>
      </div>
      <div class="myprize-content" :class="{'isTujia': isTujiaAppEnv}">
        <div class="myprize-item myprize-info">
          <img :src="picHost+activeDetail.prizePicUrl" class="prize-img" v-if="activeDetail.prizePicUrl"/>
          <div class="prize-info">
            <p class="title">{{activeDetail.prizeName}}</p>
            <p class="text">中奖时间：{{activeDetail.lotteryTime}}</p>
          </div>
        </div>
        <h3>使用说明</h3>
        <div class="detail-item" v-if="activeDetail.redeemNo"><span class="detail-title">兑换码号：</span>
          <div class="detail-text">{{activeDetail.redeemNo}}<p class="copy" @click="copyCode(activeDetail.redeemNo)">复制</p></div>
        </div>
        <div class="detail-item" v-if="activeDetail.introduceInfo && activeDetail.introduceInfo.exchange">
          <span class="detail-title">兑换方式：</span><div class="detail-text">{{activeDetail.introduceInfo.exchange}}</div>
        </div>
        <div class="detail-item" v-if="activeDetail.introduceInfo && activeDetail.introduceInfo.content">
          <span class="detail-title">权益内容：</span><div class="detail-text">{{activeDetail.introduceInfo.content}}</div>
        </div>
        <div class="bottom-btn" @click="closePrizeDetail"><img src="https://pic.tujia.com/upload/festatic/2406/02c022c7a56e69a6.png"/>返回我的奖品</div>
      </div>
    </tj-popup>
  </section>
</template>

<script>
import ClipboardJS from 'clipboard'
import Toast from './Toast'
// 弹层内容类型
const popupContentType = {
  // 实物奖品
  PRIZEINKIND: 1,
  // 贝壳
  OTHERPRIZE: 2,
  // 积分
  INTEGRAL: 3,
  // 优惠券
  COUPON: 4,
  // 红包
  REDPACKAGE: 5,
  // 没中奖
  MISSED: null,
  // 任何状态都不是
  NONE: 6,
  // 途游卡
  TUYOUCARD: 7
}
export default {
  mounted() {
    this.prizeHistoryAnimate()
  },
  components: {
    Toast
  },
  data() {
    const { isTujiaAppEnv } = this.platformEnv
    return {
      isTujiaAppEnv,
      // 转盘当前选中的奖品order
      orderNum: -1,
      // 控制弹层内容
      popupContentType: popupContentType.NONE,
      // 是否显示中奖弹层
      showDialog: false,
      // 是否显示提示信息
      showToast: false,
      // 是否显示我的奖品
      isMyPrizesShow: false,
      // 是否展示奖品详情
      prizeDetailShow: false,
      // 当前展示的他人抽奖记录的index值
      currPrizeHistoryIndex: 0,
      // 是否正在抽奖
      isDrawing: false,
      // 姓名
      name: '',
      // 电话
      phone: '',
      // 活动id
      id: '',
      // 地址
      address: '',
      // 邮编
      postCode: '',
      // toast提示信息
      toastMsg: '',
      // 中奖信息
      prize: {},
      // 后端返回中奖号码
      myPrizeOrder: -1,
      // 获奖流水id
      lotteryCode: '',
      // 抽奖结果
      prizeResult: {},
      // 邮寄地址弹层
      addressDialog: false,
      // 奖品详情
      activeDetail: {}
    }
  },
  props: {
    compId: {
      type: String,
      default: function() {
        return ''
      }
    },
    compProps: {
      type: Object,
      default: function() {
        return {
          myPrize: [],
          allPrize: {},
          otherPrize: []
        }
      }
    },
    payLoad: {
      type: Object,
      default: function() {
        return {}
      }
    }
  },
  watch: {
    /* 这里有可能需要加deep: true */
    payLoad: {
      handler(newVal) {
        switch (newVal.type) {
        case 'drawFinish':
          this.finishDraw(newVal)
          break
        case 'cantDraw':
          this.isDrawing = false
          break
        // case 'goUse':
        //   this.goUse()
        //   break
        case 'saveFinish':
          this.doAddressDialog(false)
          break
        default:
        }
      },
      deep: true
    },
    compProps: {
      handler(newVal) {
        if (newVal && newVal.id) {
          this.id = newVal.id
        }
      },
      deep: true
    }
  },
  methods: {
    // 他人抽奖记录动画
    prizeHistoryAnimate() {
      let timer = null
      clearInterval(timer)
      timer = setInterval(() => {
        this.currPrizeHistoryIndex++
        if (this.currPrizeHistoryIndex > this.compProps.otherPrize.length - 1) {
          this.currPrizeHistoryIndex = 0
        }
      }, 2000)
    },
    // toast提示
    doShowToast(msg) {
      this.msg = msg
      this.showToast = true
    },
    // 开始抽奖
    drawprize(e) {
      if (this.isDrawing) { return }
      this.isDrawing = true
      this.$emit('action', { type: 'drawprize', data: new Date().getTime() })
    },
    // /**
    //  * 立即使用 CQ逻辑
    //  */
    // goUse() {
    //   this.$emit('action', { type: 'goUse', data: new Date().getTime() })
    // },
    // 抽奖结束的回调
    finishDraw(myPrize) {
      this.prizeResult = myPrize.data
      this.prizeDrawAnimate()
    },
    // 抽奖动画
    prizeDrawAnimate() {
      this.orderNum = this.compProps.allPrize.prizeList[0].orderNum
      // 初始定时器间隔
      let time = 300
      // 转动圈数
      let n = 0
      let sum = 3 * 8 + this.prizeResult.orderNum
      let This = this
      setTimeout(() => {
        _setTimer()
      }, 300)
      function _setTimer() {
        This.orderNum++
        time -= 10
        if (This.orderNum > 8) {
          This.orderNum = 1
          n++
        }
        if (n * 8 + This.orderNum > sum - 5) {
          if (n * 8 + This.orderNum === sum) {
            clearInterval(This.timer)
            // 抽奖结果显示
            setTimeout(() => {
              This.showPrizeDrawResult()
            }, 500)
          } else {
            clearInterval(This.timer)
            This.timer = setTimeout(() => {
              _setTimer()
            }, 300)
          }
        } else {
          clearInterval(This.timer)
          This.timer = setTimeout(() => {
            _setTimer()
          }, time)
        }
      }
    },
    // 展示抽奖结果
    showPrizeDrawResult() {
      this.doShowDialog(true)
      let prizeTemp = {}
      this.prize = this.prizeResult
      prizeTemp = this.compProps.allPrize?.prizeList?.find((prize) => {
        /* eslint-disable eqeqeq */
        return prize.orderNum == this.payLoad.data.orderNum
      })
      this.prize = {
        ...this.prize,
        ...prizeTemp
      }
      /* eslint-disable eqeqeq */
      // 中奖
      if (this.prize && this.prize.prizeType) {
        this.popupContentType = this.prize.prizeType
      } else {
        // 没中奖
        this.popupContentType = popupContentType.MISSED
      }
      // 开奖后取消正在抽奖状态
      this.isDrawing = false
      // 开奖后刷新奖品列表
      this.$emit('action', { type: 'refreshPrize', data: new Date().getTime() })
    },
    // 中奖弹窗是否展示
    doShowDialog(is) {
      this.showDialog = is
      // 关闭弹层的时候清楚奖品选中
      if (!is) {
        this.orderNum = 0
        this.popupContentType = popupContentType.NONE
      }
    },
    // 中奖弹窗图片点击
    handleBtn() {
      switch (this.popupContentType) {
      case popupContentType.PRIZEINKIND:
        this.setAddress(this.prize)
        break
      case popupContentType.INTEGRAL:
        this.doShowToast('积分已到账')
        this.doShowDialog(false)
        break
      default:
        this.doShowDialog(false)
      }
    },
    // 填写地址弹窗是否展示
    doAddressDialog(is) {
      this.addressDialog = is
      // 关闭弹层的时候清楚奖品选中、清空输入框
      if (!is) {
        this.claerInput()
        this.orderNum = 0
      }
    },
    // 写地址
    setAddress(prize) {
      this.lotteryCode = prize.lotteryCode
      // 如果没有填写地址才去填写
      if (!prize.receiveAddress) {
        this.showDialog = false
        this.doAddressDialog(true)
      }
    },
    // 保存邮递地址
    confirmAddress() {
      if (!this.name.trim()) {
        this.doShowToast('请输入姓名')
      } else if (!this.phone.trim()) {
        this.doShowToast('请输入手机号')
      } else if (!this.address.trim()) {
        this.doShowToast('请输入详细快递地址')
      } else if (!this.postCode.trim()) {
        this.doShowToast('请输入邮编')
      } else {
        let telPattern = new RegExp(/^1\d{10}$/)
        if (telPattern.test(this.phone)) {
          let adressData = {
            'lotteryRecordCode': this.lotteryCode, // 获奖流水id
            'userName': this.name, // 姓名
            'mobile': this.phone, // 手机
            'address': this.address, // 地址
            'zipCode': this.postCode // 邮编
          }
          this.$emit('action', { type: 'setAddress', data: adressData })
        } else {
          this.doShowToast('请输入正确的手机号码')
        }
      }
    },
    // 我的奖品页是否展示
    isShowMyPrize(show) {
      if (this.isDrawing) { return }
      this.isMyPrizesShow = show
    },
    // 奖品详情
    checkPrizeDetail(prize) {
      if (prize && prize.prizeType === popupContentType.COUPON) { // 优惠券
        this.prizeDetailShow = true
        this.activeDetail = prize || {}
      } else if (prize && prize.prizeType === popupContentType.PRIZEINKIND && !prize.receiveAddress) { // 实物
        this.setAddress(prize)
      }
    },
    // 关闭奖品详情页
    closePrizeDetail() {
      this.prizeDetailShow = false
      this.activeDetail = {}
    },
    // 清空邮寄地址
    claerInput() {
      this.name = ''
      this.phone = ''
      this.address = ''
      this.postCode = ''
      this.popupContentType = popupContentType.NONE
    },
    copyCode(code) {
      let clipboard = new ClipboardJS('.copy', {
        text: () => {
          return code
        }
      })
      clipboard.on('success', () => {
        this.doShowToast('已复制到粘贴板')
        clipboard.destroy()
      })
      clipboard.on('error', () => {
        this.doShowToast('复制失败，请手动复制')
        clipboard.destroy()
      })
    }
  }
}

</script>

<style lang="scss" scoped>
// 转盘
.prizedraw-wrapper {
  width: 22rem;
  height: 19.2rem;
  background-size: contain;
  margin: 0 auto 0.6rem;
  position: relative;
  background-repeat: no-repeat;
}
.prizedraw-list {
  padding: 2.2rem 1.5rem;
}
.turntable-wrapper {
  padding: 0;
  margin: 0;
  display: inline-flex;
  flex-wrap: wrap;
  justify-content: space-around;
}
.prize-item {
  width: 6rem;
  height: 4.8rem;
  display: table-cell;
  position: relative;
  margin-bottom: 0.4rem;
  img {
    width: 100%;
    height: 100%;
    display: inherit;
    border-radius: 5px;
  }
}
.prize-list-btn {
  color: #fbde3b;
  text-decoration: underline;
  margin-left: 0.3rem;
}
.prize-item.active {
  .turntable-item-mark {
    display: inline-block;
  }
}
.drawBtn {
  .turntable-item-mark {
    display: none !important;
  }
}
.turntable-item {
  width: 100%;
  height: 100%;
  border-radius: 5px;
  position: absolute;
  top: 0;
}
.turntable-item-mark {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  border-radius: 5px;
  position: absolute;
  top: 0;
  display: none;
}
.prize-num {
  position: absolute;
  bottom: 0;
  left: 0;
  height: 1.5rem;
  line-height: 1.5rem;
  width: 100%;
  text-align: center;
  p {
    text-align: center;
    font-size: 12px;
    color: #ffffff;
    margin: 0;
    span {
      color: #fbde3b;
    }
  }
}
// .left-line,
// .right-line {
//   width: 2px;
//   height: 0.6rem;
//   position: absolute;
//   bottom: -0.6rem;
// }
// .left-line {
//   left: 5rem;
// }
// .right-line {
//   right: 5rem;
// }
// 获奖轮播
.prize-history {
  width: 18rem;
  height: 2.4rem;
  position: relative;
  margin: 0 auto;
  padding: 0 1.7rem;
  line-height: 2.4rem;
  background-color: #328694;
  border-radius: 17px;
  text-align: center;
  color: #fff;
  overflow: hidden;
  box-sizing: content-box;
  margin-bottom: 8px;
}
.history-wrapper {
  padding: 0;
  margin: 0;
  transition: 0.5s;
}
.history-item {
  width: 100%;
  height: 2.4rem;
  line-height: 2.4rem;
  border-radius: 17px;
  display: flex;
  justify-content: center;
  align-items: center;
  .item-icon {
    width: 1.7rem;
    height: 1.7rem;
    border-radius: 50%;
    margin-right: 0.4rem;
  }
  .item-number {
    margin-right: 0.3rem;
  }
  .item-text {
    margin-right: 0.3rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
.my-prize-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 8rem;
  height: 1.7rem;
  background-color: #fff;
  border-radius: 13px;
  font-size: 13px;
  color: #48a3b2;
  margin: 0 auto 1.2rem;
}

// 中奖弹层
.prizedraw-dialog {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.4);
  z-index: 9900;
  width: 100vw;
  height: 100vh;
  .prize-all-img {
    position: absolute;
    top: calc(50% - 3rem);
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-direction: column;
    img {
      width: 100%;
    }
    .null-prize {
      width: 274px;
    }
    .close-img {
      width: 32px;
      height: 32px;
      margin-top: 20px;
    }
  }
  @media screen and (min-width: 700px) {
    .prize-all-img {
      width: 72%;
    }
  }
}
.dialog-wrapper {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 20rem;
  background-color: #fff;
  border-radius: 3px;
  padding: 1.5rem 0;
  text-align: center;
  .dialog-close {
    position: absolute;
    right: 0.7rem;
    top: 0.7rem;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    width: 1rem;
    height: 1rem;
    display: inline-block;
    background-position: center;
  }
  .dialog-title {
    font-size: 17px;
    line-height: 1.7rem;
    color: #333;
    text-align: center;
    margin: 0.7rem 0;
  }
  .prize-name {
    font-size: 14px;
    color: #555;
  }
  .prize-image {
    height: 5.8rem;
    margin: 1.5rem 0;
    display: inline-block;
  }
  .dialog-btn {
    width: 16rem;
    height: 2.5rem;
    line-height: 2.5rem;
    background: #FF6E16;
    border-radius: 6px;
    border: none;
    color: #fff;
    font-size: 15px;
    font-family: PingFangSC-Medium;
  }
}
// 邮寄地址
.dialog-from {
  padding: 0 1.9rem;
  text-align: left;
  .from-name {
    display: flex;
    font-size: 14px;
    color: #555;
    height: 1.6rem;
    line-height: 1.6rem;
    text-align: left;
    .dialog-input {
      // width: 13.5rem;
      width: 100%;
      height: 1.6rem;
      font-size: 12px;
      padding-left: 0.3rem;
      -webkit-appearance: none;
      border: none;
    }
  }
  .from-phone,
  .from-address,
  .from-postcode {
    display: flex;
    margin-top: 0.8rem;
    font-size: 14px;
    height: 1.6rem;
    line-height: 1.6rem;
    color: #555;
    text-align: left;
    .dialog-input {
      // width: 13.5rem;
      width: 100%;
      height: 1.6rem;
      font-size: 12px;
      padding-left: 0.3rem;
      -webkit-appearance: none;
      border: none;
    }
  }
}
.dialog-address-btn {
  width: 16rem;
  height: 2.5rem;
  margin-top: 1.2rem;
  line-height: 2.5rem;
  border-radius: 6px;
  background: #FF6E16;
  border: none;
  color: #fff;
  font-size: 15px;
}
.dialog-text {
  font-family: PingFangSC-Regular;
  font-size: 14px;
  margin-top: 0.8rem;
  color: #e05a54;
}
input::-webkit-input-placeholder {
  /* WebKit browsers */
  color: #dadada;
}
input:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: #dadada;
}
input::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #dadada;
}
input::-ms-input-placeholder {
  /* Internet Explorer 10+ */
  color: #dadada;
}
.f-border-line-gray-warp {
  flex: 1;
  display: inline-block;
  height: 1.6rem;
  position: relative;
}
.f-border-line-gray:after {
  content: '';
  border: 1px solid #dadada;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 200%;
  height: 200%;
  -webkit-transform: scale(0.5);
  transform: scale(0.5);
  -webkit-transform-origin: left top;
  transform-origin: left top;
  border-radius: 0px;
  pointer-events: none;
  display: inline-block;
  position: absolute;
  top: 0;
  bottom: 0;
}
// 我的奖品
.myprize-container {
  width: 100%;
  height: 100%;
  background-color: #F4F6F9;
  overflow-y: hidden;
  -webkit-user-select: text;
  -khtml-user-select: text;
  -moz-user-select: text;
  -ms-user-select: text;
  user-select: text;
  .header-container {
    width: 100%;
    height: 44px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    background-color: #fff;
    .return-btn {
      position: absolute;
      left: 16px;
    }
    .icon-back {
      width: 24px;
      color: #222;
    }
    .title_box {
      font-size: 17px;
      font-weight: bold;
      color: #222;
    }
  }
  .myprize-content {
    flex: 1;
    height: 100vh;
    overflow-y: scroll;
    padding: 18px 16px;
    padding-bottom: 120px;
    box-sizing: border-box;
    &.isTujia {
      height: calc(100vh - 44px);
    }
    .myprize-list {
      margin-bottom: 8px;
      overflow: hidden;
    }
    .myprize-type-name {
      margin-bottom: 8px;
    }
    .myprize-item {
      background-color: #fff;
      padding: 8px 16px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      box-shadow: 0px 20px 40px -20px #0000000A;
      border-radius: 8px;
      margin-bottom: 8px;
      .prize-img {
        width: 66px;
        height: 66px;
        flex-shrink: 0;
        margin-right: 18px;
        border-radius: 10px;
      }
      .prize-info {
        flex: 1;
        .title {
          font-family: PingFangSC-Semibold;
          font-size: 16px;
          line-height: 22px;
          margin-bottom: 2px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .text {
          color: #666;
          font-size: 11px;
          line-height: 15px;
        }
      }
      .myprize-btn {
        flex-shrink: 0;
        color: #999;
        display: flex;
        align-items: center;
        font-size: 12px;
      }
      .icon-arrow {
        font-size: 12px;
      }
    }
    .myprize-info {
      margin-bottom: 12px;
    }
    h3 {
      font-size: 16px;
      line-height: 22px;
      margin-bottom: 16px;
    }
    .detail-item {
      display: flex;
      align-items: flex-start;
      margin-bottom: 16px;
      color: #666;
      line-height: 20px;
      .detail-title {
        margin-right: 16px;
        flex-shrink: 0;
      }
      .detail-text {
        white-space: pre-wrap;
        word-break: break-all;
      }
      .copy {
        color: #2682E4;
      }
    }
  }
  .bottom-btn {
    width: 158px;
    height: 50px;
    line-height: 50px;
    font-size: 16px;
    text-align: center;
    border-radius: 40px;
    background: #FFFFFF;
    box-shadow: 0px 8px 40px 0px #656c714c;
    position: absolute;
    bottom: 70px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      width: 16px;
      height: 16px;
      margin-right: 3px;
    }
  }
}
</style>
